export const alertConstants = {
  ALERT_OPEN: 'ALERT_OPEN',
  ALERT_CLOSE: 'ALERT_CLOSE',
};
